// Components
import Section from "../../../components/Section/SectionContainer";
import Vimeo from "../../../components/Vimeo/VimeoContainer";

// CSS
import styles from "../conference.module.scss";

export const ConferenceHighlightVideo = (props) => {
    const { conference } = props;
    const { highlight_video_id, is_active } = conference || {};

    return !is_active && highlight_video_id ? (
        <Section classes={styles.highlightVideo}>
            <Vimeo video={highlight_video_id} />
        </Section>
    ) : null;
};
